import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useDittoId } from '../../hooks/use-ditto-id.js';
import { vtoEvent } from '../../utils.js';
import { DittoModal } from '../DittoModal/DittoModal.js';
import { DittoPreview } from '../DittoPreview/DittoPreview.js';

const DittoContainer = ({ onClose , sku , vtoBanner  })=>{
    const [skipIntro, setSkipIntro] = React.useState(false);
    const { dittoId , setDittoId , deleteDittoId  } = useDittoId(onClose);
    const { featureConfigs  } = useFeatureToggles();
    const isDittoEnabled = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.virtualTryOn) === 'DITTO';
    React.useEffect(()=>{
        vtoEvent('vto.tryon.open', {
            sku
        });
        return ()=>vtoEvent('vto.close', {
                sku
            })
        ;
    }, []);
    if (!isDittoEnabled) {
        return null;
    }
    return dittoId ? /*#__PURE__*/ React.createElement(DittoPreview, {
        dittoId: dittoId,
        onDelete: handleDelete,
        onError: handleError,
        onRetake: handleRetake,
        sku: sku
    }) : /*#__PURE__*/ React.createElement(DittoModal, {
        onCreate: setDittoId,
        onCancel: onClose,
        onError: handleError,
        skipIntro: skipIntro,
        vtoBanner: vtoBanner,
        sku: sku
    });
    function handleRetake() {
        deleteDittoId(true);
        setSkipIntro(true);
    }
    function handleDelete() {
        deleteDittoId();
    }
    function handleError() {
        onClose();
        // @TODO implement error logging
        toast.failed('vto.errors.connection');
    }
};

export { DittoContainer };
//# sourceMappingURL=DittoContainer.js.map
